<template>
	<div class="date-time-picker">
		<div class="row">
			<div class="col-sm-12 col-date">
				<div class="row">
					<div class="col-md-6 col-lg-4">
						<erco-number-stepper class="year-stepper"
						                     :value="currentVisibleYear"
						                     :validator="inputYearValidator"
						                     @change="handleInputYear">
						</erco-number-stepper>
					</div>
					<div class="col-md-6 col-lg-8">
						<erco-dropdown class="month-stepper"
						               label=""
						               :items="months"
						               :currentItemIndex="currentMonthIndex"
						               :styleInfo="{ width: '9rem', textAlign: 'right' }"
						               @change="handleChangeMonth">
						</erco-dropdown>
					</div>
				</div>
			</div>
			<div class="col-sm-12 col-time">
				<erco-number-stepper class="hour-stepper"
				                     :min="0"
				                     :max="23"
				                     :leftPadLength="2"
						             :value="hours"
						             @change="handleChangeHour">
				</erco-number-stepper>
				:
				<erco-number-stepper class="minute-stepper"
				                     :min="0"
				                     :max="59"
				                     :leftPadLength="2"
						             :value="minutes"
						             @change="handleChangeMinute">
				</erco-number-stepper>
				Uhr
			</div>
		</div>
		<table class="table month-layer mt-5">
			<thead>
				<th v-for="item in weekdays" class="weekday-entry">{{item}}</th>
			</thead>
			<tbody>
				<tr v-for="week in weeks">
					<td v-for="day in week"
					    :class="{'day-entry': true, '-selected': day.isSelected}"
				        @click="handleClickDay(day.num)">
				    	{{day.text}}
				    </td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	import moment from 'moment';
	import ErcoNumberStepper from '@/components/atoms/ErcoNumberStepper';
	import ErcoDropdown from './ErcoDropdown';

	moment.locale('de');

	export default {
		name: 'ErcoDateTimePickerMolecule',
		data() {
			return {
				currentDay: null,
				currentMonth: null,
				currentYear: null,
				currentHours: null,
				currentMinutes: null,

				visibleYear: null,
				visibleMonth: null,

				manuallySelectedDate: moment(),
				selectedDatetime: null,
			};
		},
		props: {
			datetime: {
				type: Date,
				required: false,
			},
			fallbackDatetime: {
				type: Date,
				required: false,
				default: new Date(),
			},
		},
		methods: {
			changeYear(rel) {
				this.visibleYear = parseInt(this.currentVisibleYear, 10) + rel;
			},
			handleInputYear(value) {
				this.visibleYear = value;
			},
			inputYearValidator(value) {
				return !!value.match(/\d{4}/);
			},
			handleChangeMonth(data) {
				this.visibleMonth = parseInt(data.currentIndex, 10);
			},
			handleChangeHour(value) {
				this.currentHours = value;
				this.emitChange();
			},
			handleChangeMinute(value) {
				this.currentMinutes = value;
				this.emitChange();
			},
			handleClickDay(day) {
				if (day === undefined) {
					return;
				}
				this.currentDay = parseInt(day, 10);
				this.currentYear =
					this.visibleYear !== null ? this.visibleYear : this.currentDateTime.currentYear;
				this.currentMonth =
					this.visibleMonth !== null ? this.visibleMonth : this.currentDateTime.currentMonth;
				this.emitChange();
			},
			emitChange() {
				const newManuallySelectedDate = moment();
				newManuallySelectedDate.year(this.currentDateTime.currentYear);
				newManuallySelectedDate.month(this.currentDateTime.currentMonth);
				newManuallySelectedDate.date(this.currentDateTime.currentDay);
				newManuallySelectedDate.hours(this.currentDateTime.currentHours);
				newManuallySelectedDate.minutes(this.currentDateTime.currentMinutes);
				newManuallySelectedDate.seconds(0);

				this.manuallySelectedDate = newManuallySelectedDate;

				this.$emit('change', this.manuallySelectedDate.toDate());
			},

			isSelectedDay(day) {
				if (this.currentDateTime.currentYear === this.currentVisibleYear &&
					this.currentDateTime.currentMonth === this.currentVisibleMonth &&
					day === this.currentDay) {
					return true;
				}

				return false;
			},
		},
		components: {
			ErcoNumberStepper,
			ErcoDropdown,
		},
		computed: {
			currentDateTime() {
				if (!this.datetime) {
					this.selectedDatetime = this.fallbackDatetime;
				} else {
					this.selectedDatetime = this.datetime;
					this.manuallySelectedDate = moment(this.datetime);
				}

				this.selectedDatetime = moment(this.selectedDatetime);

				const currentDateTime = {
					currentDay: this.currentDay !== null ?
						this.currentDay :
						this.selectedDatetime.date(),
					currentMonth: this.currentMonth !== null ?
						this.currentMonth :
						this.selectedDatetime.month(),
					currentYear: this.currentYear !== null ?
						this.currentYear :
						this.selectedDatetime.year(),
					currentHours: this.currentHours !== null ?
						this.currentHours :
						this.selectedDatetime.hours(),
					currentMinutes: this.currentMinutes !== null ?
						this.currentMinutes :
						this.selectedDatetime.minutes(),
				};

				Object.keys(currentDateTime).forEach(key => (this[key] = currentDateTime[key]));

				return currentDateTime;
			},
			currentVisibleYear() {
				return this.visibleYear !== null ? this.visibleYear : this.currentDateTime.currentYear;
			},
			currentVisibleMonth() {
				return this.visibleMonth !== null ? this.visibleMonth : this.currentDateTime.currentMonth;
			},
			weeks() {
				const weeks = [];
				let days = [];
				let i = 0;
				let day = 0;
				for (i = 0; i < this.beginWeekDay - 1; i += 1) {
					days.push('');
				}
				const weeksInMonth = Math.ceil(((this.beginWeekDay - 1) + this.daysInMonth) / 7);
				for (let j = 1; j <= weeksInMonth; j += 1) {
					for (; i < 7 * j && day < this.daysInMonth; i += 1) {
						const currDay = day + 1;
						day += 1;

						days.push({
							num: currDay,
							text: currDay.toString().padStart(2, '0'),
							isSelected: this.isSelectedDay(currDay),
						});
					}
					weeks.push(days);
					days = [];
				}
				return weeks;
			},
			weekdays() {
				const weekdays = moment.weekdaysMin();
				weekdays.push(weekdays.splice(0, 1)[0]);
				return weekdays;
			},
			months() {
				const months = moment.months();
				const items = [];
				months.forEach((item) => {
					items.push({
						text: item,
					});
				});
				return items;
			},
			currentMonthIndex() {
				return this.currentDateTime.currentMonth;
			},
			years() {
				const currentYear = moment().year();
				const items = [];
				for (let i = currentYear; i < currentYear + 10; i += 1) {
					items.push({
						text: i.toString(),
					});
				}
				return items;
			},
			beginWeekDay() {
				return moment()
					 .year(this.currentVisibleYear)
					 .month(this.currentVisibleMonth)
					 .date(1)
					 .isoWeekday();
			},
			daysInMonth() {
				return moment()
					 .year(this.currentVisibleYear)
					 .month(this.currentVisibleMonth)
					 .date(1)
					 .daysInMonth();
			},
			hours() {
				return this.currentDateTime.currentHours;
			},
			minutes() {
				return this.currentDateTime.currentMinutes;
			},
		},
	};

</script>

<style lang="scss">

	.date-time-picker {
		& > .table {
			border-collapse: separate;
			border-spacing: 0;
		}

		.col-date,
		.col-time {
			text-align: left;
			white-space: nowrap;
		}

		& > .month-layer {
			.weekday-entry,
			.day-entry {
				text-align: center;
			}

			.day-entry {
				cursor: pointer;
				width: (100% / 7);
				border: 1px solid transparent;

				&:hover {
					background-color: rgba(244, 244, 244, 1);
				}
				&.-selected {
					border: 1px solid rgb(68, 157, 68);
				}
			}
		}

		.col-time {
			text-align: right;

			> .hour-stepper,
			> .minute-stepper {
				display: inline-block;
				width: 10rem;
				padding-top: 0.4rem;

				.-value {
					padding-left: 0.25rem;
					padding-right: 0.25rem;
					width: 0.5rem;
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// ErcoDateTimePicker.vue?1b8e3c6a